import captureSentryException from '../tracking/sentry/captureSentryException';

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const brazilDateFormat = (value, options = null) => {
  let delimiter;
  let upperCaseMonth;
  if (options !== null) {
    delimiter = options.delimiter;
    upperCaseMonth = options.upperCaseMonth;
  }

  try {
    const parts = value.split('-');
    const date = new Date(parts[0], parts[1] - 1, parts[2]);
    const dateTimeFormat = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: 'short', day: '2-digit' });
    const formatToParts = dateTimeFormat.formatToParts(date);
    const [{ value: day }, , { value: month }, , { value: year }] = formatToParts;
    const formattedMonth = typeof upperCaseMonth !== 'undefined' && upperCaseMonth ? month.toUpperCase() : capitalize(month);
    const formatDelimiter = typeof delimiter !== 'undefined' ? delimiter : '-';
    return `${day}${formatDelimiter}${formattedMonth.replace('.', '')}${formatDelimiter}${year}`;
  } catch (e) {
    const extras = {
      value,
    };
    captureSentryException(e, extras);
    throw new Error(`Error formatting value to brazilDateFormat: ${e}`);
  }
};

export default brazilDateFormat;
